/**
 * Global Tabs Components Exports
 *
 * @since 1.0.0
 */

export { GlobalTabsManager } from './global-tabs-manager';
export type { GlobalTabsManagerProps } from './global-tabs-manager/types';
export { TabItemRenderer } from './tab-item-renderer';
export type { TabItemRendererProps } from './tab-item-renderer/types';
export { TabModal } from './tab-modal';
export type { TabModalProps } from './tab-modal/types';
